let ownerSequence = 0
let activeOwner = null

export function createViewerOwnerId() {
  ownerSequence += 1
  return `global-file-viewer-${ownerSequence}`
}

export function claimViewer(ownerId, onPreempt) {
  if (!ownerId) return false

  if (activeOwner?.id === ownerId) {
    activeOwner.onPreempt = onPreempt
    return true
  }

  const previousOwner = activeOwner
  activeOwner = { id: ownerId, onPreempt }

  if (typeof previousOwner?.onPreempt === 'function') {
    previousOwner.onPreempt()
  }

  return true
}

export function releaseViewer(ownerId) {
  if (activeOwner?.id !== ownerId) return false

  activeOwner = null
  return true
}

export function isViewerOwner(ownerId) {
  return Boolean(ownerId && activeOwner?.id === ownerId)
}

export function resetViewerCoordinator() {
  activeOwner = null
  ownerSequence = 0
}
